import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShowMenuInitializerService {
  private noMenuRoutes = [
    '/login',
    '/reset-password',
    '/force-change-password',
    '/public-form',
    '/job-offer',
  ];

  showMenu = true;

  initialize(): Promise<void> {
    return new Promise<void>((resolve) => {
      const currentLocation = window.location.pathname;
      const routesMatchingLocation = this.noMenuRoutes.reduce((accumulator, currentValue) => {
        if (currentLocation.includes(currentValue)) {
          accumulator.push(currentValue);
        }
        return accumulator;
      }, []);
      if (routesMatchingLocation.length > 0) {
        this.showMenu = false;
      }
      resolve();
    });
  }
}
